<!--<app-header></app-header>-->
<div class="page-title">
    <h1 class="k-h1">Apply to Speak at Conference</h1>
</div>
<div class="page-container">
    <form class="k-form k-form-md" [formGroup]="formGroup" (ngSubmit)="submitForm()">
        <div class="k-messagebox k-messagebox-info">
            This form is just an example.<br />
            No payment or data is collected.<br />
            After submitting the form the corresponding income will increase in the spreadsheet in Event Budget page of
            this application.
        </div>

        <fieldset class="k-form-fieldset">
            <div class="fields-wrapper">
                <kendo-formfield>
                    <kendo-label [for]="firstnameinput">First Name</kendo-label>
                    <kendo-textbox
                        #firstnameinput
                        size="large"
                        formControlName="firstName"
                        placeholder="First Name"
                        [clearButton]="true"
                    >
                    </kendo-textbox>
                </kendo-formfield>
                <kendo-formfield>
                    <kendo-label [for]="lastNameinput">Last Name</kendo-label>
                    <kendo-textbox
                        #lastNameinput
                        size="large"
                        formControlName="lastName"
                        placeholder="Last Name"
                        [clearButton]="true"
                    >
                    </kendo-textbox>
                </kendo-formfield>
            </div>
            <kendo-formfield>
                <kendo-label [for]="emailinput">Email</kendo-label>
                <kendo-textbox
                    #emailinput
                    size="large"
                    placeholder="example@domain.com"
                    formControlName="email"
                    [clearButton]="true"
                >
                </kendo-textbox>
            </kendo-formfield>
            <kendo-formfield>
                <kendo-label 
                  [for]="jobtitleinput" 
                  text="Job Title" 
                  [optional]="true"
                >
                </kendo-label>
                <kendo-textbox #jobtitleinput size="large" formControlName="jobTitle"> </kendo-textbox>
            </kendo-formfield>
            <kendo-formfield>
                <kendo-label 
                  [for]="companynameinput" 
                  text="Company Name" 
                  [optional]="true"
                >
                </kendo-label>
                <kendo-textbox 
                  #companynameinput 
                  size="large" 
                  formControlName="companyName"
                > 
                </kendo-textbox>
            </kendo-formfield>
            <kendo-formfield>
                <kendo-label 
                  [for]="linkedinprofileinput" 
                  text="LinkedIn Profile" 
                  [optional]="true"
                >
              </kendo-label>
                <kendo-textbox 
                  #linkedinprofileinput 
                  size="large" 
                  formControlName="linkedinProfile"
                > 
                </kendo-textbox>
            </kendo-formfield>
            <kendo-formfield>
                <kendo-label [for]="preferredsessioninput">Preferred Type of Session</kendo-label>
                <kendo-dropdownlist
                    #preferredsessioninput
                    [data]="speakerType"
                    [valuePrimitive]="true"
                    size="large"
                    formControlName="speakerType"
                >
                </kendo-dropdownlist>
            </kendo-formfield>
            <kendo-formfield>
                <kendo-label [for]="suggestedtopicinput">Suggested Topic</kendo-label>
                <kendo-textbox
                    #suggestedtopicinput
                    size="large"
                    formControlName="suggestedTopics"
                    placeholder="My Sample Presentation"
                >
                </kendo-textbox>
            </kendo-formfield>
            <kendo-formfield>
                <kendo-label [for]="suggesteddescriptioninput">Suggested Description</kendo-label>
                <kendo-textarea
                    #suggesteddescriptioninput
                    size="large"
                    formControlName="suggestedDescription"
                    placeholder="Some details about the sample topic that is going to be presented on the event that is demonstrated in this application."
                >
                </kendo-textarea>
            </kendo-formfield>
        </fieldset>

        <div class="buttons-container">
            <button 
                kendoButton 
                themeColor="primary" 
                type="submit" 
                size="large" 
                style="width: 86px"
            > Apply
            </button>
            <button
              kendoButton
              type="button" 
              (click)="clearForm()" 
              size="large" 
              style="width: 80px"
            > Clear
            </button>
        </div>
    </form>
</div>

<ng-template #notificationTemplate>
    <div>Your application has been processed.<br />Spreadsheet on Event Booking page is updated.</div>
</ng-template>
